import { render, staticRenderFns } from "./CardsTotal.vue?vue&type=template&id=7c689c04"
import script from "./CardsTotal.vue?vue&type=script&lang=js"
export * from "./CardsTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports